export default __webpack_public_path__ + "static/media/vanne.96e896ee.png";